import React, { useState, useEffect } from 'react';
import { Modal, Button, Form, Row, Col, Alert, Spinner } from 'react-bootstrap';
import { staffCalculationRulesApi, ruleHelpers } from './actions';


const StaffCalculationRuleModal = ({ isOpen, onClose, ruleData, workModes, positions }) => {
  const [formData, setFormData] = useState({
    position: '',
    ruleType: 'groups',
    rulePerGroup: false,
    minGroups: 0,
    maxGroups: 0,
    workMode: '',
    specialization: '',
    maxUnits: ''
  });
  const [loading, setLoading] = useState(false);
  const [errors, setErrors] = useState({});
  const [submitError, setSubmitError] = useState('');

  useEffect(() => {
    if (ruleData) {
      setFormData({
        position: ruleData.position?.id || '',
        ruleType: ruleData.ruleType || 'groups',
        rulePerGroup: ruleData.rulePerGroup || false,
        minGroups: +ruleData.minGroups || 0,
        maxGroups: +ruleData.maxGroups || 0,
        workMode: ruleData.workMode || '',
        specialization: ruleData.specialization || '',
        maxUnits: ruleData.maxUnits || ''
      });
    } else {
      setFormData({
        position: '',
        ruleType: 'groups',
        rulePerGroup: false,
        minGroups: 0,
        maxGroups: 0,
        workMode: '',
        specialization: '',
        maxUnits: ''
      });
    }
    setErrors({});
    setSubmitError('');
  }, [ruleData, isOpen]);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    setSubmitError('');

    if(formData.ruleType == "groups") formData.minGroups = +formData.minGroups;
    if(formData.ruleType == "groups") formData.maxGroups = +formData.maxGroups;



    // Валидация
    const validationErrors = ruleHelpers.validateRuleData(formData);
    if (Object.keys(validationErrors).length > 0) {
      setErrors(validationErrors);
      setLoading(false);
      return;
    }

 
    try {
      if (ruleData) {
        // Обновление существующего правила
        await staffCalculationRulesApi.updateRule(ruleData.id, formData);
      } else {
        // Создание нового правила

        await staffCalculationRulesApi.createRule(formData);
      }
      
      onClose(true); // Закрыть модалку и обновить данные
    } catch (err) {
      const errorMessage = err.response?.data?.message || 'Помилка збереження правила';
      setSubmitError(errorMessage);
    } finally {
      setLoading(false);
    }
  };

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData(prev => ({
      ...prev,
      [name]: value
    }));
    
    // Очистка ошибки при изменении поля
    if (errors[name]) {
      setErrors(prev => ({
        ...prev,
        [name]: ''
      }));
    }
  };

  const handleRuleTypeChange = (e) => {
    const ruleType = e.target.value;
    setFormData(prev => ({
      ...prev,
      ruleType,
      minGroups: ruleType !== 'groups' ? 0 : prev.minGroups,
      maxGroups: ruleType !== 'groups' ? 0 : prev.maxGroups,
      workMode: ruleType !== 'work_mode' ? '' : prev.workMode,
      specialization: ruleType !== 'specialization' ? '' : prev.specialization
    }));

    // Очистка ошибок при смене типа правила
    setErrors({});
  };

  const renderConditionFields = () => {
    switch (formData.ruleType) {
      case 'groups':
        return (
          <Row>
            <Col md={6}>
              <Form.Group className="mb-3">
                <Form.Label>Мінімальна кількість груп *</Form.Label>
                <Form.Control
                  type="number"
                  name="minGroups"
                  value={formData.minGroups}
                  onChange={handleChange}
                  required
                  min="0"
                  isInvalid={!!errors.minGroups}
                  placeholder="Введіть мін. кількість груп"
                />
                <Form.Control.Feedback type="invalid">
                  {errors.minGroups}
                </Form.Control.Feedback>
              </Form.Group>
            </Col>
            <Col md={6}>
              <Form.Group className="mb-3">
                <Form.Label>Максимальна кількість груп *</Form.Label>
                <Form.Control
                  type="number"
                  name="maxGroups"
                  value={formData.maxGroups}
                  onChange={handleChange}
                  required
                  min="0"
                  isInvalid={!!errors.maxGroups}
                  placeholder="Введіть макс. кількість груп"
                />
                <Form.Control.Feedback type="invalid">
                  {errors.maxGroups}
                </Form.Control.Feedback>
              </Form.Group>
            </Col>
          </Row>
        );
      
      case 'work_mode':
        return (
          <Form.Group className="mb-3">
            <Form.Label>Режим роботи ЗДО *</Form.Label>
            <Form.Select
              name="workMode"
              value={formData.workMode}
              onChange={handleChange}
              required
              isInvalid={!!errors.workMode}
            >
              <option value="">Оберіть режим роботи</option>
              {workModes.map((mode, index) => (
                <option key={index} value={mode}>{mode}</option>
              ))}
            </Form.Select>
            <Form.Control.Feedback type="invalid">
              {errors.workMode}
            </Form.Control.Feedback>
          </Form.Group>
        );
      
      case 'specialization':
        return (
          <Form.Group className="mb-3">
            <Form.Label>Спеціалізація ЗДО *</Form.Label>
            <Form.Control
              type="text"
              name="specialization"
              value={formData.specialization}
              onChange={handleChange}
              required
              isInvalid={!!errors.specialization}
              placeholder="Введіть спеціалізацію ЗДО"
            />
            <Form.Control.Feedback type="invalid">
              {errors.specialization}
            </Form.Control.Feedback>
          </Form.Group>
        );
      
      default:
        return null;
    }
  };

  return (
    <Modal show={isOpen} onHide={onClose} size="lg">
      <Modal.Header closeButton>
        <Modal.Title>
          {ruleData ? 'Редагувати правило' : 'Додати нове правило'}
        </Modal.Title>
      </Modal.Header>
      
      <Form onSubmit={handleSubmit}>
        <Modal.Body>
          {submitError && (
            <Alert variant="danger" className="mb-3">
              {submitError}
            </Alert>
          )}

          <Form.Group className="mb-3">
            <Form.Label>Посада *</Form.Label>
            <Form.Select
              name="position"
              value={formData.position}
              onChange={handleChange}
              required
              isInvalid={!!errors.position}
            >
              <option value="">Оберіть посаду</option>
              {positions.map((position) => (
                <option key={position.id} value={position.id}>
                  {position.name} ({position.type})
                </option>
              ))}
            </Form.Select>
            <Form.Control.Feedback type="invalid">
              {errors.position}
            </Form.Control.Feedback>
          </Form.Group>

          <Form.Group className="mb-3">
            <Form.Label>Тип правила *</Form.Label>
            <Form.Select
              name="ruleType"
              value={formData.ruleType}
              onChange={handleRuleTypeChange}
              required
              isInvalid={!!errors.ruleType}
            >
              <option value="groups">За кількістю груп</option>
              <option value="work_mode">За режимом роботи</option>
              <option value="specialization">За спеціалізацією ЗДО</option>
            </Form.Select>
            <Form.Control.Feedback type="invalid">
              {errors.ruleType}
            </Form.Control.Feedback>
          </Form.Group>

          {renderConditionFields()}

          <Form.Group className="mb-3">
            <Form.Label>Максимальна кількість штатних одиниць *</Form.Label>
            <Form.Control
              type="number"
              name="maxUnits"
              value={formData.maxUnits}
              onChange={handleChange}
              required
              min="0"
              step="0.5"
              isInvalid={!!errors.maxUnits}
              placeholder="Введіть максимальну кількість шт. од."
            />
            <Form.Control.Feedback type="invalid">
              {errors.maxUnits}
            </Form.Control.Feedback>
            <Form.Text className="text-muted">
              Можна вводити дробові значення (0.5, 1.5 тощо)
            </Form.Text>
          </Form.Group>

          <Form.Group className="mb-3">
            <Form.Check
              type="checkbox"
              id="checkbox_rule_proporc"
              label="Дія правила прямо пропорційно кількості груп"
              checked={formData.rulePerGroup}
              onChange={(e)=>setFormData(prev=>({...prev, rulePerGroup: e.target.checked }))}
            />
            <Form.Text className="text-muted">
              Впливає на метод розрахунку. Якщо обрано, кількість розраховується як: Максимальна_кількість_шт_од * число_груп
            </Form.Text>
          </Form.Group>

        </Modal.Body>
        <Modal.Footer>
          <Button variant="secondary" onClick={onClose} disabled={loading}>
            Скасувати
          </Button>
          <Button variant="primary" type="submit" disabled={loading}>
            {loading && <Spinner animation="border" size="sm" className="me-2" />}
            {ruleData ? 'Зберегти зміни' : 'Додати правило'}
          </Button>
        </Modal.Footer>
      </Form>
    </Modal>
  );
};

export default StaffCalculationRuleModal;